<template>
    <div id="partsFooter" class="parts-footer">
        <div class="footer-header" v-if="isDesktop">
            <h3 v-html="resources.heading"></h3>
            <p v-html="resources.body"></p>
        </div>
        <product-parts :isDesktop="isDesktop"></product-parts>
        <status-bar v-show="shouldShowStatusBar"></status-bar>
        <div class="button-row">
            <button class="btn btn--secondary" @click="cancel()">{{ resources.decline }}</button>
            <button class="btn" :disabled=shouldShowStatusBar @click="accept()">{{ resources.accept }}</button>
        </div>
    </div>
</template>

<script src="./parts-footer.js"></script>
